import { Markdown } from "@/components/Markdown";
import styled from "@emotion/styled";
import { type Opportunity } from "@repo/api";
import { Text, Variables } from "@repo/skapa";
import { getLanguageAndLocaleFromUrl, t } from "@repo/translation";
import { FlexDiv } from "@repo/ui";

interface ProjectSummaryProps {
  opportunity: Opportunity;
}

const Container = styled(FlexDiv)`
  flex-direction: column;
  gap: ${Variables.space50};
  padding-bottom: ${Variables.space100};
`;

export const ProjectSummary = ({ opportunity }: ProjectSummaryProps) => {
  const locale = getLanguageAndLocaleFromUrl();

  const languageCode = locale?.language ?? "en";
  const summary = opportunity.aiProjectData?.summaries?.[languageCode];

  return (
    <Container>
      <Text textStyle="Heading.XS">{t("label.key_insights")}</Text>
      {summary ? (
        <Markdown>{summary}</Markdown>
      ) : (
        <Text>{t("prompt.no_summary_available")}</Text>
      )}
    </Container>
  );
};
